import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ReviewSetupForm from './ReviewSetupForm';

/**
 * A review tab that was never set up (#189, #317): the same setup as the
 * "+ New review" dialog, inline on the tab, so a tab left behind by a reload
 * or a closed dialog still has exactly one way forward.
 */
export default function ReviewCreate({ threadId }: { threadId: string }) {
  return (
    <Box data-testid="review-create" sx={{ flex: 1, overflow: 'auto', display: 'flex', justifyContent: 'center', p: 3 }}>
      <Box sx={{ width: '100%', maxWidth: 480, display: 'grid', gap: 2, alignContent: 'start', mt: 3 }}>
        <Box>
          <Typography sx={{ fontSize: 22, fontWeight: 700, letterSpacing: '-0.01em' }}>Start a review</Typography>
          <Typography variant="caption" sx={{ color: 'text.secondary', lineHeight: 1.55 }}>
            Grounded on a perspective, refreshed on a schedule, built from pinned analyses. Grounding is chosen here and never changes silently.
          </Typography>
        </Box>
        <Box sx={{ p: 2, border: '1px solid', borderColor: 'divider', borderRadius: 2.5, bgcolor: 'background.paper' }}>
          <ReviewSetupForm threadId={threadId} />
        </Box>
      </Box>
    </Box>
  );
}
